/* iSYFIX Touch Gallery v4.1 (motor v4.1) — mobile gestures for the engine PDP gallery.
   v1 pan · v2 swipe · v3 pinch + back-gesture. v4 adds:
   - FLUID CONVEYOR SWIPE (stage + lightbox): the photo follows the finger 1:1 while the
     neighbor photo slides in beside it; releasing commits with an iOS-style ease curve
     (cubic-bezier(0.32,0.72,0,1)) or springs back below the threshold. Quick flicks
     advance via velocity. Neighbor images preload on touchstart (thumbs carry the
     full-res data-src, so the incoming pane is the exact final asset — no quality pop).
   - BADGES DOCKED BELOW THE IMAGE ON TOUCH DEVICES: .ix-product__stage-tr (ship chip +
     dynamic badges_v2 pills) relocates under the stage as a wrapping row, so pills never
     cover the product photo on phones. Same nodes, same [data-when] — the engine keeps
     toggling them per variant. Desktop keeps the on-image look.
   v4.1 adds:
   - STICKY ATC ON SCROLL: the engine's mobile sticky bar (.ix-product__sticky) appears only
     after the real Add-to-Cart button scrolls out of the viewport (IntersectionObserver, no
     scroll listeners), slides in/out with the same iOS curve, hides while the lightbox is
     open, and tapping its variant/price area scrolls back to the buybox. The hidden-state
     CSS + safe-area padding live server-side in sections/isyfix-axes-data.liquid (no flash).
   Self-contained: document-level delegation, synthetic clicks drive the engine's handlers. */
(function () {
  'use strict';

  var EASE_COMMIT = 'cubic-bezier(0.32, 0.72, 0, 1)';
  var EASE_CANCEL = 'cubic-bezier(0.25, 0.8, 0.35, 1)';
  var REDUCED = false;
  try { REDUCED = matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  var st = document.createElement('style');
  st.textContent =
    '.ix-lightbox__body{touch-action:none;position:relative}' +
    '.ix-product__stage{touch-action:pan-y}' +
    '.ix-product__stage-tr.ix-badges-docked{position:static;top:auto;right:auto;flex-direction:row;flex-wrap:wrap;align-items:center;justify-content:flex-start;gap:6px;margin:10px 2px 0}' +
    '.ix-product__stage-tr.ix-badges-docked > *{margin:0}';
  document.head.appendChild(st);

  /* ============ Badges: dock below the stage on touch devices ============ */
  function dockBadges() {
    var coarse = false;
    try { coarse = matchMedia('(hover: none) and (pointer: coarse)').matches; } catch (e) {}
    var stages = document.querySelectorAll('.ix-product__stage');
    for (var i = 0; i < stages.length; i++) {
      var stage = stages[i];
      var col = stage.parentNode;
      if (!col) continue;
      var tr = stage.querySelector('.ix-product__stage-tr');
      if (!tr) {
        var docked = col.querySelector(':scope > .ix-product__stage-tr.ix-badges-docked');
        if (!docked) continue;
        tr = docked;
      }
      if (coarse) {
        if (!tr.classList.contains('ix-badges-docked')) {
          tr.classList.add('ix-badges-docked');
          col.insertBefore(tr, stage.nextSibling);
        }
      } else if (tr.classList.contains('ix-badges-docked')) {
        tr.classList.remove('ix-badges-docked');
        stage.appendChild(tr);
      }
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', dockBadges);
  } else { dockBadges(); }
  try {
    matchMedia('(hover: none) and (pointer: coarse)').addEventListener('change', dockBadges);
  } catch (e) {}

  /* ============ Sticky ATC: appears only after the buybox button scrolls away ============ */
  function initStickyAtc() {
    var bars = document.querySelectorAll('.ix-product__sticky');
    for (var i = 0; i < bars.length; i++) {
      (function (bar) {
        var root = bar.closest('[id^="ix-product-"]') || document;
        var atc = root.querySelector('[data-atc]');
        if (!atc || !window.IntersectionObserver) { bar.classList.add('is-on'); return; } /* fallback: legacy always-on */
        var lb = root.querySelector('.ix-lightbox');
        var atcGone = false;
        function sync() {
          bar.classList.toggle('is-on', atcGone && !(lb && !lb.hidden));
        }
        var io = new IntersectionObserver(function (entries) {
          var en = entries[entries.length - 1];
          /* show only when the button left through the TOP (user scrolled past the buybox) */
          atcGone = !en.isIntersecting && en.boundingClientRect.top < 0;
          sync();
        }, { threshold: 0 });
        io.observe(atc);
        if (lb) new MutationObserver(sync).observe(lb, { attributes: true, attributeFilter: ['hidden'] });
        var info = bar.querySelector('.ix-product__sticky-info');
        if (info && !info.__ixBound) {
          info.__ixBound = true;
          info.style.cursor = 'pointer';
          info.addEventListener('click', function () {
            try { atc.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'center' }); }
            catch (err) { atc.scrollIntoView(); }
          });
        }
      })(bars[i]);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyAtc);
  } else { initStickyAtc(); }

  /* ============ Gesture state ============ */
  var drag = null;        /* zoomed-image pan: {img, body, x, y, ox, oy, scale, moved} */
  var swipe = null;       /* swipe candidate: {kind, el, x, y, dir, root, vis, idx, img, box, strip} */
  var pinch = null;       /* pinch zoom: {img, body, d0, s0, moved} */
  var conv = null;        /* conveyor: {img, ghost, box, W, base, nIdx, dx, vx, lastX, lastT} */
  var swallowUntil = 0;   /* absorb the trusted ghost click that follows a gesture */

  function originPct(img) {
    var o = (img.style.transformOrigin || '50% 50%').split(' ');
    return { x: parseFloat(o[0]) || 50, y: parseFloat(o[1]) || 50 };
  }
  function scaleOf(img) {
    var m = /scale\(([\d.]+)\)/.exec(img.style.transform || '');
    var s = m ? parseFloat(m[1]) : 2.4;
    return s > 1 ? s : 2.4;
  }
  function dist(t1, t2) {
    var dx = t1.clientX - t2.clientX, dy = t1.clientY - t2.clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }
  function visibleThumbs(root) {
    var pool = root.querySelectorAll('.ix-product__rail [data-thumb]');
    if (!pool.length) pool = root.querySelectorAll('.ix-product__thumbs-mobile [data-thumb]');
    var vis = [];
    pool.forEach(function (t) { if (!t.hidden) vis.push(t); });
    vis.sort(function (a, b) { return (parseInt(a.style.order, 10) || 0) - (parseInt(b.style.order, 10) || 0); });
    return vis;
  }
  function activeIndex(list, cls) {
    for (var i = 0; i < list.length; i++) { if (list[i].classList.contains(cls || 'is-active')) return i; }
    return 0;
  }
  function preload(src) {
    if (!src) return;
    try { var im = new Image(); im.src = src; } catch (e) {}
  }
  function stepStage(stageEl, delta) {
    var root = stageEl.closest('[id^="ix-product-"]') || document;
    var vis = visibleThumbs(root);
    if (vis.length < 2) return;
    var next = vis[(activeIndex(vis) + delta + vis.length) % vis.length];
    if (next) next.click();
  }
  function stepLightbox(lbEl, delta) {
    var strip = lbEl.querySelector('.ix-lightbox__strip');
    if (!strip) return;
    var btns = strip.querySelectorAll('button');
    if (btns.length < 2) return;
    var next = btns[(activeIndex(btns) + delta + btns.length) % btns.length];
    if (next) next.click();
  }

  /* ============ Conveyor (fluid swipe) ============ */
  function convStart(s, dx) {
    if (REDUCED) return null;
    if (!s.img || !s.box || !s.vis || s.vis.length < 2) return null;
    var W = s.box.clientWidth;
    if (!W) return null;
    var c = {
      img: s.img, box: s.box, W: W, dx: dx, vx: 0,
      lastX: 0, lastT: 0, ghost: null, base: 0, nIdx: -1,
      kind: s.kind, vis: s.vis, idx: s.idx, strip: s.strip || null
    };
    c.img.style.transition = 'none';
    c.img.style.willChange = 'transform';
    convGhost(c, dx < 0 ? 1 : -1);
    return c;
  }
  function convGhost(c, delta) {
    if (c.ghost && c.ghost.parentNode) c.ghost.parentNode.removeChild(c.ghost);
    c.nIdx = (c.idx + delta + c.vis.length) % c.vis.length;
    c.base = delta > 0 ? c.W : -c.W;
    var src = c.vis[c.nIdx] ? c.vis[c.nIdx].dataset.src : '';
    var g = document.createElement('img');
    g.className = c.img.className;
    g.setAttribute('aria-hidden', 'true');
    g.style.cssText = 'position:absolute;left:0;top:0;right:0;bottom:0;margin:auto;width:100%;height:100%;transition:none;will-change:transform;background:#fff;';
    if (c.kind === 'lb') {
      g.style.width = 'auto';
      g.style.height = 'auto';
      g.style.maxWidth = '92%';
      g.style.maxHeight = '96%';
    }
    g.src = src;
    g.style.transform = 'translateX(' + (c.dx + c.base) + 'px)';
    c.img.parentNode.insertBefore(g, c.img.nextSibling);
    c.ghost = g;
  }
  function convMove(c, dx, x, now) {
    if ((dx < 0 && c.base < 0) || (dx > 0 && c.base > 0)) convGhost(c, dx < 0 ? 1 : -1);
    c.dx = dx;
    if (c.lastT) {
      var dt = Math.max(1, now - c.lastT);
      c.vx = 0.75 * c.vx + 0.25 * ((x - c.lastX) / dt);
    }
    c.lastX = x; c.lastT = now;
    c.img.style.transform = 'translateX(' + dx + 'px)';
    if (c.ghost) c.ghost.style.transform = 'translateX(' + (dx + c.base) + 'px)';
  }
  function convFinish(c) {
    var commit = Math.abs(c.dx) > c.W * 0.32 ||
      (Math.abs(c.dx) > 30 && Math.abs(c.vx) > 0.45 && (c.vx < 0) === (c.dx < 0));
    swallowUntil = Date.now() + 450;
    var img = c.img, ghost = c.ghost, base = c.base;
    function cleanup() {
      if (ghost && ghost.parentNode) ghost.parentNode.removeChild(ghost);
      img.style.transition = 'none';
      img.style.transform = '';
      img.style.willChange = '';
      void img.offsetWidth;
      requestAnimationFrame(function () { img.style.transition = ''; });
    }
    if (commit && ghost) {
      var doStep = c.kind === 'lb'
        ? function () {
            if (c.strip) {
              var btns = c.strip.querySelectorAll('button');
              if (btns[c.nIdx]) btns[c.nIdx].click();
            }
          }
        : function () { if (c.vis[c.nIdx]) c.vis[c.nIdx].click(); };
      var done = false;
      var finish = function () {
        if (done) return; done = true;
        doStep();
        /* the engine sets the img src to the same URL the ghost showed (cached) —
           keep the ghost on top for one frame while the real img resets beneath it */
        img.style.transition = 'none';
        img.style.transform = '';
        setTimeout(cleanup, 60);
      };
      img.style.transition = 'transform 300ms ' + EASE_COMMIT;
      ghost.style.transition = 'transform 300ms ' + EASE_COMMIT;
      img.style.transform = 'translateX(' + (-base) + 'px)';
      ghost.style.transform = 'translateX(0px)';
      ghost.addEventListener('transitionend', finish, { once: true });
      setTimeout(finish, 380);
    } else {
      img.style.transition = 'transform 240ms ' + EASE_CANCEL;
      if (ghost) ghost.style.transition = 'transform 240ms ' + EASE_CANCEL;
      img.style.transform = 'translateX(0px)';
      if (ghost) ghost.style.transform = 'translateX(' + base + 'px)';
      setTimeout(cleanup, 280);
    }
  }
  function convAbort() {
    if (!conv) return;
    var c = conv; conv = null;
    if (c.ghost && c.ghost.parentNode) c.ghost.parentNode.removeChild(c.ghost);
    c.img.style.transition = 'none';
    c.img.style.transform = '';
    c.img.style.willChange = '';
    void c.img.offsetWidth;
    c.img.style.transition = '';
  }

  /* ============ Touch handlers ============ */
  document.addEventListener('touchstart', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;

    if (e.touches.length === 2) {
      convAbort();
      var lbBody2 = target.closest('.ix-lightbox__body');
      if (lbBody2) {
        var img2 = lbBody2.querySelector('.ix-lightbox__img');
        if (img2) {
          drag = null; swipe = null;
          var s0 = img2.classList.contains('is-zoomed') ? scaleOf(img2) : 1;
          if (s0 === 1) {
            var r0 = lbBody2.getBoundingClientRect();
            var mx = (e.touches[0].clientX + e.touches[1].clientX) / 2;
            var my = (e.touches[0].clientY + e.touches[1].clientY) / 2;
            var px = Math.min(100, Math.max(0, (mx - r0.left) / r0.width * 100));
            var py = Math.min(100, Math.max(0, (my - r0.top) / r0.height * 100));
            img2.style.transformOrigin = px + '% ' + py + '%';
          }
          img2.style.transition = 'none';
          pinch = { img: img2, body: lbBody2, d0: dist(e.touches[0], e.touches[1]), s0: s0, moved: false };
        }
      }
      return;
    }

    if (e.touches.length !== 1) { drag = null; swipe = null; return; }
    if (pinch) return; /* finishing a pinch — handled on touchend */
    drag = null; swipe = null;
    var t = e.touches[0];

    var lbBody = target.closest('.ix-lightbox__body');
    if (lbBody) {
      var zoomed = lbBody.querySelector('.ix-lightbox__img.is-zoomed');
      if (zoomed) {
        var o = originPct(zoomed);
        drag = { img: zoomed, body: lbBody, x: t.clientX, y: t.clientY, ox: o.x, oy: o.y, scale: scaleOf(zoomed), moved: false };
      } else {
        var lbEl = lbBody.closest('.ix-lightbox');
        var root = lbEl.closest('[id^="ix-product-"]') || document;
        var strip = lbEl.querySelector('.ix-lightbox__strip');
        var btns = strip ? strip.querySelectorAll('button') : [];
        var vis = visibleThumbs(root);
        var idx = activeIndex(btns);
        if (vis.length !== btns.length) vis = null; /* fallback state — no conveyor */
        swipe = {
          kind: 'lb', el: lbEl, x: t.clientX, y: t.clientY, dir: null,
          root: root, vis: vis, idx: idx, strip: strip,
          img: lbEl.querySelector('.ix-lightbox__img'), box: lbBody
        };
        if (vis && vis.length > 1) {
          preload(vis[(idx + 1) % vis.length].dataset.src);
          preload(vis[(idx - 1 + vis.length) % vis.length].dataset.src);
        }
      }
      return;
    }
    var stage = target.closest('.ix-product__stage');
    if (stage && !stage.querySelector('.ix-stage-video')) {
      var root2 = stage.closest('[id^="ix-product-"]') || document;
      var vis2 = visibleThumbs(root2);
      var idx2 = activeIndex(vis2);
      swipe = {
        kind: 'stage', el: stage, x: t.clientX, y: t.clientY, dir: null,
        root: root2, vis: vis2, idx: idx2,
        img: stage.querySelector('[data-main-image]') || stage.querySelector('.ix-product__photo'), box: stage
      };
      if (vis2.length > 1) {
        preload(vis2[(idx2 + 1) % vis2.length].dataset.src);
        preload(vis2[(idx2 - 1 + vis2.length) % vis2.length].dataset.src);
      }
    }
  }, { passive: true, capture: true });

  document.addEventListener('touchmove', function (e) {
    if (pinch && e.touches.length === 2) {
      if (e.cancelable) e.preventDefault();
      var d = dist(e.touches[0], e.touches[1]);
      if (!pinch.d0) return;
      var s = Math.min(5, Math.max(1, pinch.s0 * (d / pinch.d0)));
      pinch.moved = true;
      pinch.img.style.transform = 'scale(' + s.toFixed(3) + ')';
      pinch.img.classList.toggle('is-zoomed', s > 1.02);
      return;
    }

    if (e.touches.length !== 1) return;
    var t = e.touches[0];

    if (drag) {
      var dx0 = t.clientX - drag.x;
      var dy0 = t.clientY - drag.y;
      if (!drag.moved && Math.abs(dx0) < 8 && Math.abs(dy0) < 8) return;
      if (!drag.moved) { drag.moved = true; drag.img.style.transition = 'none'; }
      if (e.cancelable) e.preventDefault();
      var r = drag.body.getBoundingClientRect();
      var f = drag.scale - 1;
      var ox = drag.ox - (dx0 / f) / r.width * 100;
      var oy = drag.oy - (dy0 / f) / r.height * 100;
      drag.img.style.transformOrigin =
        Math.min(100, Math.max(0, ox)) + '% ' + Math.min(100, Math.max(0, oy)) + '%';
      return;
    }

    if (!swipe) return;
    var dx = t.clientX - swipe.x;
    var dy = t.clientY - swipe.y;
    if (!swipe.dir) {
      if (Math.abs(dx) < 10 && Math.abs(dy) < 10) return;
      swipe.dir = Math.abs(dx) > Math.abs(dy) * 1.2 ? 'h' : 'v';
      if (swipe.dir === 'h' && !conv) conv = convStart(swipe, dx);
    }
    if (swipe.dir === 'h') {
      if (e.cancelable) e.preventDefault();
      if (conv) convMove(conv, dx, t.clientX, Date.now());
    }
  }, { passive: false, capture: true });

  function endDrag() {
    if (!drag) return;
    drag.img.style.transition = '';
    if (drag.moved) swallowUntil = Date.now() + 450;
    drag = null;
  }
  function endPinch(e) {
    if (!pinch) return;
    var img = pinch.img, body = pinch.body;
    var m = /scale\(([\d.]+)\)/.exec(img.style.transform || '');
    var s = m ? parseFloat(m[1]) : pinch.s0;
    img.style.transition = '';
    if (pinch.moved) swallowUntil = Date.now() + 450;
    if (s <= 1.05) {
      img.classList.remove('is-zoomed');
      img.style.transform = '';
      img.style.transformOrigin = '';
    } else if (e && e.touches && e.touches.length === 1) {
      /* hand off pinch -> one-finger pan without lifting */
      var t = e.touches[0];
      var o = originPct(img);
      drag = { img: img, body: body, x: t.clientX, y: t.clientY, ox: o.x, oy: o.y, scale: s > 1 ? s : 2.4, moved: true };
      drag.img.style.transition = 'none';
    }
    pinch = null;
  }
  document.addEventListener('touchend', function (e) {
    if (pinch) { if (e.touches.length < 2) endPinch(e); return; }
    if (drag) { endDrag(); return; }
    if (!swipe) { if (conv) { var cx = conv; conv = null; convFinish(cx); } return; }
    var s = swipe; swipe = null;
    if (conv) {
      var c = conv; conv = null;
      convFinish(c);
      return;
    }
    /* fallback (reduced motion / fallback state): instant step like v3 */
    if (s.dir !== 'h') return;
    var t = e.changedTouches && e.changedTouches[0];
    if (!t) return;
    var dx = t.clientX - s.x;
    if (Math.abs(dx) < 48) return;
    swallowUntil = Date.now() + 450;
    var delta = dx < 0 ? 1 : -1;
    if (s.kind === 'stage') stepStage(s.el, delta);
    else stepLightbox(s.el, delta);
  }, { passive: true, capture: true });
  document.addEventListener('touchcancel', function () { endDrag(); endPinch(null); convAbort(); swipe = null; }, { passive: true, capture: true });

  /* Ghost-click guard (trusted clicks only; synthetic .click() passes). */
  document.addEventListener('click', function (e) {
    if (!e.isTrusted) return;
    if (Date.now() > swallowUntil) return;
    if (e.target && e.target.closest && (e.target.closest('.ix-lightbox') || e.target.closest('.ix-product__stage'))) {
      swallowUntil = 0;
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);

  /* == Back gesture / back button closes the lightbox instead of leaving the page == */
  var lbPushed = false, lbFromPop = false;
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var el = muts[i].target;
      if (!el.classList || !el.classList.contains('ix-lightbox')) continue;
      var open = !el.hidden;
      if (open && !lbPushed) {
        try { history.pushState({ ixLb: 1 }, ''); lbPushed = true; } catch (err) {}
      } else if (!open && lbPushed) {
        lbPushed = false;
        if (!lbFromPop) { try { history.back(); } catch (err) {} }
        lbFromPop = false;
      }
    }
  }).observe(document.documentElement, { attributes: true, attributeFilter: ['hidden'], subtree: true });

  window.addEventListener('popstate', function () {
    var lb = document.querySelector('.ix-lightbox:not([hidden])');
    if (!lb) return;
    lbFromPop = true;
    var x = lb.querySelector('[data-lb-close]');
    if (x) { x.click(); }
    else { lb.hidden = true; document.documentElement.style.overflow = ''; }
  });
})();